import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/types-att.svg',
})
export class TypesAttComponent {}
